import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./PrintCashReceipts.module.css"
import plus from "../../../Assets/plus.svg"
import run from "../../../Assets/run.svg"
import RCCGLogo from "../../../Assets/rotating-logo.png"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { ToWords } from 'to-words';


const PrintCashReceipts = () => {
  const location = useLocation();
  const { selectedLedger } = location.state || {};
  console.log(selectedLedger)
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState(null);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }
      if (saved) {
        setCashbook(JSON.parse(saved));
      }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };



  const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: true,
      currencyOptions: {
        name: "Naira",
        plural: "Naira",
        symbol: "₦",
        fractionalUnit: {
          name: 'Kobo',
          plural: 'Kobo',
          symbol: 'K',
        },
      }
    }
  });





  const handlePrint = () => {
    window.print();
  };

  function formatName(name) {
    const parts = name.split(' ');

    // If more than 4 parts, shorten it
    if (parts.length > 4) {
      return `${parts[0]} ${parts[1]} ${parts[2].charAt(0)}.`;
    }

    // Check total length of up to 4 parts
    const joined = parts.slice(0, 4).join(' ');
    if (joined.length > 45) {
      return joined.substring(0, 45) + '...';
    }

    return name;
  }

  const formattedName = selectedLedger?.particular ? formatName(selectedLedger.particular) : selectedLedger?.invoice?.customer?.name;

  console.log(selectedLedger)

  // Returns [firstPart, secondPart] based on rough line limiting
const splitTextIntoTwoParts = (text, containerWidth, charsPerLineApprox = 8) => {
  if (!text || !containerWidth) {
    return [text || "—", ""];
  }

  const words = text.split(" ");
  let currentLine = "";
  let firstPartWords = [];
  let lineCount = 0;

  for (const word of words) {
    const test = currentLine ? currentLine + " " + word : word;

    // Very rough: ~8px per character (tune this number after testing!)
    if (test.length * charsPerLineApprox > containerWidth * 1.1) {
      lineCount++;
      if (lineCount >= 2) break; // stop after roughly 2 lines
    }

    currentLine = test;
    firstPartWords.push(word);
  }

  const first = firstPartWords.join(" ");
  const second = words.slice(firstPartWords.length).join(" ");

  return [first, second || " "];
};

const descriptionRef = useRef(null);
const [descParts, setDescParts] = useState(["", ""]);

useEffect(() => {
  if (!descriptionRef.current) return;

  const width = descriptionRef.current.clientWidth;

  const [part1, part2] = splitTextIntoTwoParts(
    selectedLedger?.description || "—",
    width,
    8.5
  );

  setDescParts([part1, part2]);
}, [selectedLedger?.description]);

  return (
    <div  style={{ backgroundColor: "#f9f9f9"}}>
      <HeaderNav className={classes.hdNv}/>
        <div className={classes.topContainer}>

        <div style={{ marginTop: 12 }} />


        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Cash Receipt</h3>
            {/* <p className={classes.prgText}>Cash receipt issued on {selectedLedger?.transaction_date
              ? new Date(selectedLedger?.transaction_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
              : "--"}</p> */}
          </div>

          <div className={classes.filterIcons}>
            <img src={MailLogo} alt="icon1" className={classes.iconBtn} onClick={() => console.log("icon1")} />
            <img onClick={() => handlePrint()} src={PrintLogo} alt="icon2" className={classes.iconBtn} />
            <img src={DownloadLogo} alt="icon3" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          </div>

        </div>

      </div>
<div className={classes.containere}>
    
        <div className={classes.mainContainer}>

          <div className={classes.bckground}>
            <img src={RCCGLogo} ></img>
          </div>

          <div className={classes.mainHeader}>
            <h1> The Redeemed Christian Church of God</h1>
            <h3>National Secretariat</h3>
            <h4>OFFICIAL RECEIPT</h4>
          </div>

          <div className={`${classes.section} ${classes.section1}`}>
            <span className={classes.flexData}>
              <h5>Date:</h5>
              <p className={classes.border} style={{ width: '150px' }}>{selectedLedger?.transaction_date}</p>
            </span>
            <span className={classes.flexData}>
              <h4>No.:</h4>
              <p className={classes.border} style={{ width: '150px' }}>{selectedLedger?.id}</p>
            </span>
          </div>

          <div className={`${classes.section} ${classes.section2}`}>
            <span className={classes.flexData}>
             
             

            </span>
            <span className={classes.flexData}>
              <h4>Amount:</h4>
              <div className={classes.amountBorder}>
                <p>
                  {selectedLedger?.currency?.symbol || '₦'}
                  {parseFloat(selectedLedger?.currency_amount || selectedLedger.total_amount).toLocaleString('en-US', {
                    minimumIntegerDigits: 1,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </p>
              </div>
            </span>
          </div>
          <div className={`${classes.section} ${classes.section3}`}>
            <span className={classes.amountInWord}>
              <h4 className={classes.amtDiv}>Received From:</h4>
              <div className={classes.fullWith}>
                <p className={classes.border}>
                 {formattedName}
                </p>
              </div>
            </span>
          </div>
          <div className={`${classes.section} ${classes.section3}`}>
            <span className={classes.amountInWord}>
              <h4 className={classes.amtDiv}>Amount in Words:</h4>
              <div className={classes.fullWith}>
                <p className={classes.border}>
                  {selectedLedger?.currency_amount ? toWords.convert(parseFloat(selectedLedger?.currency_amount || selectedLedger?.total_amount)) : toWords.convert(parseFloat(selectedLedger.total_amount))}
                  <span style={{ marginLeft: "1px" }}> {selectedLedger?.currency?.currency || "Naira"} Only </span>
                </p>
              </div>
            </span>
          </div>

          <div className={`${classes.section} ${classes.section4}`}>
            <span>
              <h4>For Payment of:</h4>
              <div className={classes.fullWith}>
                  <p ref={descriptionRef} className={classes.borderss}>
              {descParts[0] || selectedLedger?.description || "—"}
            </p>

            <p style={{ marginTop: "25px" }} className={classes.borderss1}>
              {descParts[1] || " "}
            </p>
              </div>
            </span>
          </div>
<div className={classes.flexBom}>
  <div className={classes.section6}>
            <span style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <h4>Received By</h4>
              {/* <div></div> */}
              <p style={{ borderBottom: '2px solid black', width: '200px', textAlign: 'center' }}>{selectedLedger?.user?.name}</p>
            </span>
          </div>
          <div className={classes.section5}>
            
            <span className={classes.flexData}>
              <h4>Teller/ Cheque No</h4>
              <p style={{ borderBottom: '2px solid black', width: '200px', textAlign: 'center' }}>{selectedLedger?.teller_number || selectedLedger?.receipt_number || selectedLedger?.invoice_number}</p>
            </span>
          </div>

          
</div>
        </div>
        </div>
    </div>
  )
}

export default PrintCashReceipts;